import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'pobble-components/dist/setup/sentry'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/app/app'

import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducer'
import { requestMiddleware } from 'pobble-components/dist/redux-helpers'

import injectSheet from 'react-jss'
import 'normalize.css'
import { PobbleStyles } from 'pobble-components/dist/styles'
import { posthog } from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

window.posthog = posthog

const posthogOptions = {
  api_host: 'https://eu.posthog.com',
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  disable_session_recording: true
}

const StyledApp = injectSheet({
  '@global': {
    body: {
      backgroundColor: '#fff'
    },
    a: {
      color: 'var(--blue)',
      textDecoration: 'none',
      fontWeight: 'bold'
    }
  }
})(App)

const store = createStore(
  rootReducer,
  applyMiddleware(requestMiddleware, thunk)
)

ReactDOM.render(
  <PostHogProvider
    apiKey="phc_m6fAJjfR7jb7zKLkCtHOehLuDegky6k0xbDfdYxnWqs"
    options={posthogOptions}>
    <Provider store={store}>
      <PobbleStyles>
        <StyledApp />
      </PobbleStyles>
    </Provider>
  </PostHogProvider>,
  document.getElementById('root')
)

// Lazy load external tools
setTimeout(() => import('pobble-components/dist/setup/external-tools'), 1000)
